module.exports = __webpack_public_path__ + "static/media/dn.e38d6594.png";